module.exports = __webpack_public_path__ + "media/pourquoi_donner/bitmap-82500c3f.png";